import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import lang from './lang'
import { getlang } from 'src/helper/getlang'
import Toast from 'src/component/Toast'
import Loading from 'src/component/Loading'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.serviceStore = this.props.store.register('app/service')
  }
  state = {
    lang: lang.ar,
    language:'en',
  }

  async componentWillMount() {
    console.log('componentWillMount')
    let language = await getlang()
    // language = 'ar'
    switch (language) {
      case 'ar':
        this.setState({
          lang: lang.ar
        })
        break
      case 'tr':
        this.setState({
          lang: lang.tr
        })
        break
      default:
        this.setState({
          lang: lang.en
        })
        break
    }

    // this.serviceStore.setFeedbackContent({
    //   id: 0,
    //   content: "",
    //   reply: "",
    //   isReplied: 2,
    //   score: 0,
    //   isRead: 2,
    // })

    let uid = await setUidToken(this.props.location.query)

    let { id } = this.props.location.query
    id = parseInt(id)
    if (id > 0) {
      this.serviceStore.feedbackGet(id)
      this.serviceStore.feedbackRead(id)
    }
  }

  async componentDidMount() {
    console.log('componentDidMount')
    setDocumentTitle(this.state.lang.title)
    window.scroll(0, 0)
  }

  starsContent(score) {
    let score2 = 5 - score
    var items = []
    let ii = 0
    if (score > 0) {
      for (let i = 0; i < score; i++) {
        ii++
        items.push(
          <div className="star">
            <img
              src="/img/app/service/star.png"
              onClick={() => {
                this.setScore(i + 1)
              }}
            />
          </div>
        )
      }
    }
    if (score2 > 0) {
      for (let i = 0; i < score2; i++) {
        items.push(
          <div className="star">
            <img
              src="/img/app/service/star2.png"
              onClick={() => {
                this.setScore(i + 1 + ii)
              }}
            />
          </div>
        )
      }
    }

    return (
      <div className="scoreR">
        <div className="score">{items}</div>
        <div className="review">
          {score == 5 ? this.state.lang.score5 : ''}
          {score == 4 ? this.state.lang.score4 : ''}
          {score == 3 ? this.state.lang.score3 : ''}
          {score == 2 ? this.state.lang.score2 : ''}
          {score == 1 ? this.state.lang.score1 : ''}
        </div>
      </div>
    )
  }

  setScore(score) {
    console.log('score', score)
    if (this.serviceStore.data.feedbackContent.isReplied != 1 || this.serviceStore.data.feedbackContent.scoreY > 0) {
      return
    }
    if (score > 0 && score < 6) {
      this.serviceStore.setScore(score)
    }
  }

  async feedbackScore() {
    if (
      this.serviceStore.data.feedbackContent.score == undefined ||
      this.serviceStore.data.feedbackContent.score == 0
    ) {
      this.serviceStore.setToastContent(this.state.lang.pleaseScore)
      this.refs.toast.hideRule(true)
      return
    }

    let map = {
      id: this.serviceStore.data.feedbackContent.id || 0,
      score: this.serviceStore.data.feedbackContent.score
    }
    let d = await this.serviceStore.feedbackScore(map)
    if (d.code == 0) {
      this.serviceStore.setToastContent(this.state.lang.success)
      this.refs.toast.hideRule(true)
    } else {
      this.serviceStore.setToastContent(this.state.lang.fail)
      this.refs.toast.hideRule(true)
    }

    this.serviceStore.feedbackGet(this.serviceStore.data.feedbackContent.id)
  }

  render() {
    let language = this.state.language
    // language = 'ar'
    let data = this.serviceStore.data
    let { feedbackContent, toastContent, loading } = data
    return (
      <div className={`service ${language == 'ar' && 'arlang'}`}>
        {/* <Nav lang={this.state.lang} nav={2} language={language} /> */}
        <div className="feedbackContent">
          {/* 内容 */}
          <div className="title">{this.state.lang.des}</div>
          <div className="content">{feedbackContent.content}</div>
          {/* 图片 */}
          {/* <div className="title">{this.state.lang.picDesc}</div> */}
          {/* <div className="content"></div> */}
          {/* 回复 */}
          <div className="title">{this.state.lang.reply}</div>
          <div className="reply">
            {feedbackContent.isInvalid == 1 && (
              <div className="detail" dangerouslySetInnerHTML={{ __html: this.state.lang.invalid || '' }}></div>
            )}
            {feedbackContent.isInvalid != 1 && feedbackContent.reply && feedbackContent.reply != '' && (
              <div className="detail" dangerouslySetInnerHTML={{ __html: feedbackContent.reply || '' }}></div>
            )}
            {feedbackContent.isInvalid != 1 && feedbackContent.reply && feedbackContent.reply == '' && (
              <div className="detail" dangerouslySetInnerHTML={{ __html: this.state.lang.noReply || '' }}></div>
            )}
          </div>
          {feedbackContent.isReplied == 1 && <div className="title2">{this.state.lang.score}</div>}
          {feedbackContent.isReplied == 1 && this.starsContent(feedbackContent.score)}
          {feedbackContent.scoreY == 0 && feedbackContent.isReplied == 1 && (
            <div
              className={`btn`}
              onClick={() => {
                this.feedbackScore()
              }}
            >
              {this.state.lang.submit}
            </div>
          )}
        </div>
        <Toast language={language} lang={this.state.lang} ref="toast" id="toast" toastContent={toastContent} />
        <Loading ref="loading" id="loading" status={loading} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/service/feedbackContent.js